import {
  KEYCLOAK_AUTH_COOKIE_NAME,
  resolveBooleanFlag,
  resolveOidcAuthority,
  resolveOidcScope,
} from '@metaforcelabs/docgen-identity-web'

export const config = {
  // apiBaseUrl: 'https://localhost:5001',
  //apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  //apiBaseUrl: 'https://api.dialog.stage.metaforcelabs.com',
  smartformUrl: process.env.REACT_APP_SMARTFORM_URL,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  apiDigitalSigning: process.env.REACT_APP_API_DIGITALSIGNING_URL,
  tokenStorageKey: '@MetaForce:userToken',
  identityBaseUrl: process.env.REACT_APP_IDENTITY_BASE_URL,
  centerpointBaseUrl: process.env.REACT_APP_CENTERPOINT_BASE_URL,
  centerpointUiBaseUrl: process.env.REACT_APP_CENTERPOINT_UI_BASE_URL,
  digitalSigningUiBaseUrl: process.env.REACT_APP_DIGITALSIGNING_UI_BASE_URL,
  smartFormsUiBaseUrl: process.env.REACT_APP_PRODUCT_URL_SMARTFORMS,
  productLicense: '611b8ac465064876fb35e1cf',
  appBaseUrl: process.env.REACT_APP_REDIRECT_URI,
  docsUrl: process.env.REACT_APP_DOCUMENTATION_URL
}

// export const oidcConfig = {
//   client_id: 'centerpoint_web',
//   redirect_uri: 'http://localhost:3000/authentication/callback',
//   response_type: 'code',
//   post_logout_redirect_uri: 'http://localhost:3000',
//   scope: 'openid profile email api.internal offline_access',
//   authority: 'https://identity.stage.metaforcelabs.com',
//   silent_redirect_uri: 'http://localhost:3000/authentication/silent_callback',
//   automaticSilentRenew: true,
//   loadUserInfo: true,
// };

// The cookie name has to byte-match AuthProxy's KeycloakProxyCookieMiddleware.CookieName in
// CenterPoint - a different service in a different language, with no test spanning both - which
// is why it is a named export rather than a string each app types for itself. The realm name
// and the offline_access rule come from the same package for the same reason: they are
// properties of the realm and of whichever provider answers, not of this app. What stays here
// is this app's own scope list and client id.
const useKeycloak = resolveBooleanFlag(KEYCLOAK_AUTH_COOKIE_NAME, process.env.REACT_APP_USE_KEYCLOAK)
const authority = resolveOidcAuthority(process.env.REACT_APP_AUTHORITY, useKeycloak)
const scope = resolveOidcScope('openid profile email api.internal', useKeycloak)

export const oidcConfig = {
    client_id: 'smartdocs_web',
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    response_type: 'code',
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
    scope,
    authority,
    silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI,
    automaticSilentRenew: true,
    loadUserInfo: true,
  };

//export const oidcConfig = {
  //   client_id: 'centerpoint_web',
  //   redirect_uri: 'https://dialog.stage.metaforcelabs.com/authentication/callback',
  //   response_type: 'code',
  //   post_logout_redirect_uri: 'https://dialog.stage.metaforcelabs.com/',
  //   scope: 'openid profile email api.internal offline_access',
  //   authority: 'https://identity.stage.metaforcelabs.com',
  //   silent_redirect_uri: 'https://dialog.stage.metaforcelabs.com/authentication/silent_callback',
  //   automaticSilentRenew: true,
  //   loadUserInfo: true,
  // };